import { render, staticRenderFns } from "./DisplayName.vue?vue&type=template&id=3a2b55e2&scoped=true&"
import script from "./DisplayName.vue?vue&type=script&lang=ts&"
export * from "./DisplayName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b55e2",
  null
  
)

export default component.exports